import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";

export default function Layout({ children }) {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" in window ? "auto" : "auto" });
  }, [pathname]);

  return (
    <>
      <Header />
      <main data-testid="main-content" className="pt-20 min-h-screen" style={{ background: "var(--zt-bg)" }}>
        {children}
      </main>
      <Footer />
    </>
  );
}
